<template>
<div class="contact-container">
  <div class="contact">
    <div class="contact__title row text-center">
      <div class="col-12">
        聯絡我們
      </div>
    </div>
    <div class="contact__subtitle row text-center">
      <div class="col-12">
        DKSH Hong Kong Limited
      </div>
      <div class="col-12">
        大昌華嘉香港有限公司
      </div>
    </div>

    <div class="contact__items row text-center justify-content-center">
      <div class="col-sm-12 col-md-2">
        <a href="https://www.google.com.hk/maps/place/SOUTHMARK/@22.249049,114.1643218,19z/data=!4m5!3m4!1s0x34040018d827732b:0xbba21061bdcde893!8m2!3d22.249044!4d114.164869?hl=zh" target="_blank">
          <div class="symbol">
            <img src="../../assets/locationSymbol.png" v-bind:srcset="ls2x+' 2x'"/>
          </div>
          <!--
          <p>
            23/F, Tower A, Southmark, 11 Yip Hing Street, Wong Chuk Hang, Hong Kong
          </p>
          -->
          <p>
            香港黃竹坑業興街 11 號南匯廣場 A 座 23 樓
          </p>
        </a>
      </div>
      <div class="col-6 col-md-2">
        <a href="tel:+852 28959515">
          <div class="symbol">
            <img src="../../assets/telSymbol.png" v-bind:srcset="ts2x+' 2x'"/>
          </div>
          <p>
            查詢熱線
          </p>
          <p>
            2895 9515
          </p>
        </a>
      </div>
      <div class="col-6 col-md-2">
        <a href="https://www.facebook.com/Combat.HK/" target="_blank">
          <div class="symbol">
            <img src="../../assets/facebookSymbol.png" v-bind:srcset="fs2x+' 2x'"/>
          </div>
          <p>
            Facebook
          </p>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  data () {
    return {
      ls2x: require('../../assets/locationSymbol@2x.png'),
      ts2x: require('../../assets/telSymbol@2x.png'),
      fs2x: require('../../assets/facebookSymbol@2x.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.page

  > .contact-container
    padding-bottom: 165px

.contact-container
  height: 100%
  background-color: black
  display: flex
  align-items: center

.contact
  color: white
  padding-top: 15vh
  padding-bottom: 15vh
  width: 100%

  &__title
    font-size: 28px 
    line-height: normal

    @media only screen and (max-width: 768px)
      font-size: 24px

  &__subtitle
    margin-top: 2vh
    font-size: 20px 
    line-height: normal

    @media only screen and (max-width: 768px)
      font-size: 16px

  &__items
    margin-top: 7vh
    text-align: center

    a
     color: white

    p
      max-width: 240px
      margin: auto
      font-size: 16px
      line-height: 23px

    .symbol
      margin-bottom: 30px

      img
        width: 100px

  .row
    margin-left: 0
    margin-right: 0

</style>



// WEBPACK FOOTER //
// Contact.vue?c14ba33c